import styled from 'styled-components'

import { CommonMarginAndPadding } from 'components/layout'
import mediaQueries from 'components/media-queries'

export const PageContent = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  background-color: ${({ theme }) => theme.colors.white};
`

export const MobileBannerContainer = styled.div`
  display: none;
  ${mediaQueries.mobile`
  display: flex;
  background-image: url(${({ bkg }) => bkg});
  background-size: cover;
  background-image: linear-gradient(to right, rgba(57, 111, 165, 0.63) 1%, rgba(255, 255, 255, 0)),
      url(${({ bkg }) => bkg});
  height: 238px;
 `};
`

export const TopContainer = styled.div`
  height: 100%;
  min-height: 315px;
  background-position: right;
  background-image: linear-gradient(to right, rgba(57, 111, 165, 0.63) 1%, rgba(255, 255, 255, 0)),
    url(${({ bkg }) => bkg});
  background-size: 100%;
  background-repeat: no-repeat;
  background-size: cover;
  padding: 15px 30px;
  margin-bottom: 15px;
  ${mediaQueries.tablet`
   padding: 15px 70px;
  `};
  ${mediaQueries.mobile`
   padding: 0;
   height: 100%;
   min-height: auto;
   background-image: none;
  `};
`

export const TopContentWrapper = styled.div`
  padding: 15px 0;

  ${CommonMarginAndPadding};

  ${mediaQueries.tablet`
    padding: 0;
  `};
`

export const BottomContainer = styled.div`
  height: 100%;
  padding: 30px 0;
  max-width: 1200px;
  margin: 0 auto;
  ${mediaQueries.tablet`
   padding: 15px 70px;
  `};
  ${mediaQueries.mobile`
    margin: 16px 0;
    padding: 0;
  `};
`
